import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  RecordMaterialPurchasesFromReceiptDocumentInput,
  RecordMaterialPurchasesFromReceiptDocumentMutation,
} from '@/gql/graphql';

const RECORD_MATERIAL_PURCHASES_FROM_RECEIPT_DOCUMENT_MUTATION = graphql(`
  mutation RecordMaterialPurchasesFromReceiptDocument(
    $input: RecordMaterialPurchasesFromReceiptDocumentInput!
  ) {
    recordMaterialPurchasesFromReceiptDocument(input: $input) {
      id
    }
  }
`);

const useRecordMaterialPurchasesFromReceiptDocument = (
  options?: UseMutationOptions<
    RecordMaterialPurchasesFromReceiptDocumentMutation,
    unknown,
    RecordMaterialPurchasesFromReceiptDocumentInput
  >
) => {
  return useMutation({
    mutationFn: (input: RecordMaterialPurchasesFromReceiptDocumentInput) => {
      return gqlClient.request(
        RECORD_MATERIAL_PURCHASES_FROM_RECEIPT_DOCUMENT_MUTATION,
        {
          input,
        }
      );
    },
    ...options,
  });
};

export default useRecordMaterialPurchasesFromReceiptDocument;
